<template>
    <header class="wow animate__animated animate__fadeInLeftBig sticky-top sticky-header">
        <nav class="navbar navbar-expand-lg">
            <div class="container-fluid px-md-5 px-sm-2">
                <router-link class="navbar-brand" to="/">
                    <img src="../assets/img/logo-fresto.svg" alt="">
                </router-link>
                <!-- Botão da Navbar -->
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbar"
                    aria-controls="navbar" aria-expanded="false" aria-label="Toggle navigation">
                    <div class="menu-btn">
                        <div class="btn-line"></div>
                        <div class="btn-line"></div>
                        <div class="btn-line"></div>
                    </div>
                </button>

                <!-- Menu Colapsável -->
                <div class="collapse navbar-collapse" id="navbar">
                    <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                        <li class="nav-item">
                            <router-link class="nav-link" to="/conheca-fresto">Conheça o Fresto</router-link>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="/#unidades">Unidades</a>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/eventos">Eventos</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/produtos">Produtos</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/contato">Contato</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/trabalhe-conosco">Entre para o nosso time</router-link>
                        </li>
                    </ul>
                    <form class="d-flex" role="delivery">
                        <router-link to="{ name: 'DeliveryPage' }" class="btn-link">
                            <button
                                class="btn btn-delivery rounded-pill d-flex align-items-center justify-content-center"
                                type="button">
                                <img src="../assets/img/delivery-clock.svg" width="24" class="me-2" alt="">
                                Delivery
                            </button>
                        </router-link>
                    </form>
                </div>
            </div>
        </nav>
    </header>
</template>

<script>
export default {
    name: 'HeaderComponent',
};
</script>

<style scoped>
/* Adicione aqui os estilos específicos do header, se necessário */
</style>
